<template>
  <div id="my-content" ref="top">
    <Header/>
    <main id="root" v-if="titleFlag">
      <div
          v-if="mongoFlag"
          id="PaylineWidget"
          :data-token="paymentUrl"
          ref="PaylineWidgetRef"
      ></div>
      <section class="section">

        <div id="is-song-template" class="container-small is-song-template">
          <div class="song-header">
            <div class="song-wrap">
              <div class="song-player">

                <div class="song-top">
                  <div class="song__info-wrap" :class="{'with_company': song.supportByCompany}">
                    <div class="song__author-img-wrap">
                      <img v-if="titleFlag && song.authorPhotoUrl"
                           :src="song.authorPhotoUrl"
                           alt="Song author image"
                           class="song__author-img"
                           @error="imgOnError"
                           loading="lazy"
                      >
                      <img v-else
                           src="@/assets/img/default-account-image.png"
                           class="song__author-img"
                           alt="Song author default image"
                           loading="lazy"
                      >
                    </div>
                    <div class="song-author-info-top">
                      <div class="song-author-info-top-item">
                        <h1 class="song-title" v-text="song.songTitle" v-if="titleFlag"></h1>

                        <button
                            class="song__favorite-btn mobile"
                            v-if="isLogged && !song.subscribedIeo && song.status !== 'SUCCESS'"
                            @click="followIeo"
                        >
                          <svg width="53" height="46" viewBox="0 0 53 46" fill="none"
                               xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M47.4938 5.44871C46.2808 4.2351 44.8405 3.27237 43.2553 2.61554C41.6701 1.9587 39.971 1.62063 38.2551 1.62063C36.5392 1.62063 34.8401 1.9587 33.2548 2.61554C31.6696 3.27237 30.2294 4.2351 29.0163 5.44871L26.4988 7.96621L23.9813 5.44871C21.531 2.99845 18.2078 1.6219 14.7426 1.6219C11.2774 1.6219 7.95409 2.99845 5.50382 5.44871C3.05355 7.89898 1.677 11.2223 1.677 14.6875C1.677 18.1527 3.05355 21.4759 5.50382 23.9262L8.02132 26.4437L26.4988 44.9212L44.9763 26.4437L47.4938 23.9262C48.7074 22.7132 49.6702 21.2729 50.327 19.6877C50.9838 18.1025 51.3219 16.4034 51.3219 14.6875C51.3219 12.9716 50.9838 11.2725 50.327 9.68725C49.6702 8.10203 48.7074 6.66176 47.4938 5.44871V5.44871Z"
                                stroke="#FF0090" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </button>

                        <button
                            class="song__favorite-btn mobile"
                            v-if="isLogged && song.subscribedIeo && song.status !== 'SUCCESS'"
                            @click="unfollowIeo"
                        >
                          <svg width="53" height="46" viewBox="0 0 53 46" fill="#FE0190"
                               xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M47.4938 5.44871C46.2808 4.2351 44.8405 3.27237 43.2553 2.61554C41.6701 1.9587 39.971 1.62063 38.2551 1.62063C36.5392 1.62063 34.8401 1.9587 33.2548 2.61554C31.6696 3.27237 30.2294 4.2351 29.0163 5.44871L26.4988 7.96621L23.9813 5.44871C21.531 2.99845 18.2078 1.6219 14.7426 1.6219C11.2774 1.6219 7.95409 2.99845 5.50382 5.44871C3.05355 7.89898 1.677 11.2223 1.677 14.6875C1.677 18.1527 3.05355 21.4759 5.50382 23.9262L8.02132 26.4437L26.4988 44.9212L44.9763 26.4437L47.4938 23.9262C48.7074 22.7132 49.6702 21.2729 50.327 19.6877C50.9838 18.1025 51.3219 16.4034 51.3219 14.6875C51.3219 12.9716 50.9838 11.2725 50.327 9.68725C49.6702 8.10203 48.7074 6.66176 47.4938 5.44871V5.44871Z"
                                stroke="#FF0090" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </button>

                      </div>
                      <div class="song-author-info-top-item" v-if="titleFlag">
                        <router-link :to="{path: `/artist/${singerUsername}`}"
                                     class="pending-ieo-list-item-name-artist-link">
                          <span class="pending-ieo-list-item-name-artist" v-text="singerName"></span>
                        </router-link>
                      </div>
                    </div>

                    <button
                        class="song__favorite-btn desktop"
                        v-if="isLogged && !song.subscribedIeo && song.status !== 'SUCCESS'"
                        @click="followIeo"
                    >
                      <svg width="53" height="46" viewBox="0 0 53 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M47.4938 5.44871C46.2808 4.2351 44.8405 3.27237 43.2553 2.61554C41.6701 1.9587 39.971 1.62063 38.2551 1.62063C36.5392 1.62063 34.8401 1.9587 33.2548 2.61554C31.6696 3.27237 30.2294 4.2351 29.0163 5.44871L26.4988 7.96621L23.9813 5.44871C21.531 2.99845 18.2078 1.6219 14.7426 1.6219C11.2774 1.6219 7.95409 2.99845 5.50382 5.44871C3.05355 7.89898 1.677 11.2223 1.677 14.6875C1.677 18.1527 3.05355 21.4759 5.50382 23.9262L8.02132 26.4437L26.4988 44.9212L44.9763 26.4437L47.4938 23.9262C48.7074 22.7132 49.6702 21.2729 50.327 19.6877C50.9838 18.1025 51.3219 16.4034 51.3219 14.6875C51.3219 12.9716 50.9838 11.2725 50.327 9.68725C49.6702 8.10203 48.7074 6.66176 47.4938 5.44871V5.44871Z"
                            stroke="#FF0090" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>

                    <button
                        class="song__favorite-btn desktop"
                        v-if="isLogged && song.subscribedIeo && song.status !== 'SUCCESS'"
                        @click="unfollowIeo"
                    >
                      <svg width="53" height="46" viewBox="0 0 53 46" fill="#FE0190" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M47.4938 5.44871C46.2808 4.2351 44.8405 3.27237 43.2553 2.61554C41.6701 1.9587 39.971 1.62063 38.2551 1.62063C36.5392 1.62063 34.8401 1.9587 33.2548 2.61554C31.6696 3.27237 30.2294 4.2351 29.0163 5.44871L26.4988 7.96621L23.9813 5.44871C21.531 2.99845 18.2078 1.6219 14.7426 1.6219C11.2774 1.6219 7.95409 2.99845 5.50382 5.44871C3.05355 7.89898 1.677 11.2223 1.677 14.6875C1.677 18.1527 3.05355 21.4759 5.50382 23.9262L8.02132 26.4437L26.4988 44.9212L44.9763 26.4437L47.4938 23.9262C48.7074 22.7132 49.6702 21.2729 50.327 19.6877C50.9838 18.1025 51.3219 16.4034 51.3219 14.6875C51.3219 12.9716 50.9838 11.2725 50.327 9.68725C49.6702 8.10203 48.7074 6.66176 47.4938 5.44871V5.44871Z"
                            stroke="#FF0090" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>
                  </div>
                  <div class="song__company-associated-wrap desktop" v-if="song.supportByCompany">
                    <p class="song__company-associated-text">sign by</p>
                    <router-link v-if="song.companyUserName" :to="{path: `/company/${song.companyUserName}`}"
                                 class="song__company-associated">
                      <img v-if="song.companyAvatar" :src="song.companyAvatar" class="song__company-associated-img"
                           alt="Company manager image" loading="lazy">
                      <img v-else src="@/assets/img/company-avatar__default.png" class="song__company-associated-img"
                           alt="Default company manager image" loading="lazy">
                    </router-link>
                    <div v-else class="song__company-associated">
                      <img v-if="song.companyAvatar" :src="song.companyAvatar" class="song__company-associated-img"
                           alt="Company manager image" loading="lazy">
                      <img v-else src="@/assets/img/company-avatar__default.png" class="song__company-associated-img"
                           alt="Default company manager image" loading="lazy">
                    </div>
                  </div>
                </div>

                <div class="song-bottom">

                  <div class="song-bottom-header">
                    <button class="song-co-authors-btn"
                            type="button"
                            v-if="coAuthorsList.length"
                            @click="toggleCoAuthorsList"
                            :class="{'open': coAuthorsListOpen}"
                    >
                      <span class="song-co-authors-btn-text">Co-authors ({{ coAuthorsList.length }})</span>
                      <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L4.5 4L8 1" stroke="#747474" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>
                    <div class="song__company-associated-wrap mobile" v-if="song.supportByCompany">
                      <p class="song__company-associated-text">Sign by</p>
                      <router-link v-if="song.companyUserName" :to="{path: `/company/${song.companyUserName}`}"
                                   class="song__company-associated">
                        <img v-if="song.companyAvatar" :src="song.companyAvatar" class="song__company-associated-img"
                             alt="Company manager image" loading="lazy">
                        <img v-else src="@/assets/img/company-avatar__default.png" class="song__company-associated-img"
                             alt="Default company manager image" loading="lazy">
                      </router-link>
                      <div v-else class="song__company-associated">
                        <img v-if="song.companyAvatar" :src="song.companyAvatar" class="song__company-associated-img"
                             alt="Company manager image" loading="lazy">
                        <img v-else src="@/assets/img/company-avatar__default.png" class="song__company-associated-img"
                             alt="Default company manager image" loading="lazy">
                      </div>
                    </div>
                  </div>

                  <transition name="fade" tag="div">
                    <div class="song-co-authors-list" v-if="coAuthorsListOpen">
                      <a class="song-co-authors-list-item"
                         v-for="(coAuthors, index) in coAuthorsList"
                         :key="index"
                         :href="coAuthors.socialLink"
                         target="_blank"
                      >
                      <span class="song-co-authors-list-item-content"
                            v-text="coAuthors.description"></span>
                        <span class="co-authors-dot-item">,</span>
                      </a>
                    </div>
                  </transition>

                </div>

              </div>
            </div>
            <div class="song-information">
              <div class="artist-information-subscribe-wrap" v-if="titleFlag">
                <svg width="22" height="14" viewBox="0 0 22 14" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M15 6C16.66 6 17.99 4.66 17.99 3C17.99 1.34 16.66 0 15 0C13.34 0 12 1.34 12 3C12 4.66 13.34 6 15 6ZM7 6C8.66 6 9.99 4.66 9.99 3C9.99 1.34 8.66 0 7 0C5.34 0 4 1.34 4 3C4 4.66 5.34 6 7 6ZM7 8C4.67 8 0 9.17 0 11.5V13C0 13.55 0.45 14 1 14H13C13.55 14 14 13.55 14 13V11.5C14 9.17 9.33 8 7 8ZM15 8C14.71 8 14.38 8.02 14.03 8.05C14.05 8.06 14.06 8.08 14.07 8.09C15.21 8.92 16 10.03 16 11.5V13C16 13.35 15.93 13.69 15.82 14H21C21.55 14 22 13.55 22 13V11.5C22 9.17 17.33 8 15 8Z"
                        fill="#B4B4B4"></path>
                </svg>
                <span
                    v-text="song.subscribers + ' subscribers' ? song.subscribers + ' subscribers' : '0' + ' subscribers'"></span>
              </div>
              <div class="artist-information-location-wrap" v-if="titleFlag">
                <svg width="13" height="16" viewBox="0 0 13 16" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0.75 5.76477C0.75 2.58098 3.33098 -9.16285e-07 6.51477 0C9.69856 0 12.2795 2.58098 12.2795 5.76477C12.2795 9.60795 6.51477 15.3727 6.51477 15.3727C6.51477 15.3727 0.75 9.60795 0.75 5.76477ZM4.11278 5.76477C4.11278 7.09135 5.18819 8.16676 6.51477 8.16676C7.84135 8.16676 8.91676 7.09135 8.91676 5.76477C8.91676 4.43819 7.84135 3.36278 6.51477 3.36278C5.18819 3.36278 4.11278 4.43819 4.11278 5.76477H4.11278Z"
                        fill="#B4B4B4"></path>
                </svg>
                <span v-text="song.country"></span>
              </div>
              <div class="share-desc" @click="shareOpen = !shareOpen">
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M12.001 9.00969C11.558 9.01261 11.1212 9.11351 10.7219 9.30512C10.3226 9.49674 9.97079 9.77431 9.69172 10.1179L5.86797 8.35824C6.04775 7.80844 6.04775 7.21578 5.86797 6.66598L9.69172 4.90632C10.1428 5.44992 10.7716 5.81691 11.4673 5.94252C12.1629 6.06814 12.8806 5.94431 13.4937 5.59289C14.1068 5.24146 14.5759 4.68504 14.8182 4.02181C15.0605 3.35858 15.0605 2.63119 14.818 1.968C14.5756 1.30482 14.1064 0.748478 13.4932 0.397165C12.8801 0.0458517 12.1623 -0.0778483 11.4667 0.0478961C10.7711 0.17364 10.1423 0.540746 9.69137 1.08442C9.24041 1.6281 8.99623 2.3134 9.00195 3.01937C9.0042 3.19776 9.02176 3.37562 9.05443 3.55101L5.09572 5.37057C4.67366 4.95842 4.13921 4.67982 3.55932 4.56969C2.97943 4.45955 2.37989 4.52277 1.83581 4.75142C1.29174 4.98007 0.827326 5.364 0.500761 5.85508C0.174195 6.34617 0 6.92258 0 7.51211C0 8.10163 0.174195 8.67804 0.500761 9.16913C0.827326 9.66022 1.29174 10.0441 1.83581 10.2728C2.37989 10.5014 2.97943 10.5647 3.55932 10.4545C4.13921 10.3444 4.67366 10.0658 5.09572 9.65364L9.05443 11.4732C9.02176 11.6486 9.0042 11.8265 9.00195 12.0048C9.00195 12.5972 9.17784 13.1763 9.50738 13.6689C9.83691 14.1614 10.3053 14.5453 10.8533 14.772C11.4013 14.9987 12.0043 15.058 12.5861 14.9424C13.1678 14.8269 13.7022 14.5416 14.1216 14.1227C14.541 13.7039 14.8267 13.1702 14.9424 12.5892C15.0581 12.0082 14.9987 11.4059 14.7717 10.8586C14.5447 10.3114 14.1603 9.84357 13.6671 9.51446C13.174 9.18535 12.5941 9.00969 12.001 9.00969ZM12.001 1.52179C12.2975 1.52179 12.5875 1.60963 12.8341 1.77418C13.0807 1.93874 13.2728 2.17263 13.3863 2.44627C13.4998 2.71992 13.5295 3.02103 13.4717 3.31154C13.4138 3.60204 13.271 3.86888 13.0613 4.07832C12.8516 4.28776 12.5844 4.43039 12.2935 4.48818C12.0026 4.54596 11.7011 4.5163 11.4271 4.40295C11.1531 4.28961 10.9189 4.09766 10.7542 3.85138C10.5894 3.60511 10.5015 3.31557 10.5015 3.01937C10.5015 2.62219 10.6594 2.24128 10.9407 1.96043C11.2219 1.67957 11.6033 1.52179 12.001 1.52179ZM3.0039 9.00969C2.70732 9.00969 2.41741 8.92185 2.17081 8.7573C1.92422 8.59274 1.73202 8.35885 1.61853 8.08521C1.50503 7.81156 1.47534 7.51045 1.5332 7.21994C1.59106 6.92944 1.73387 6.6626 1.94358 6.45316C2.15329 6.24372 2.42048 6.10109 2.71136 6.0433C3.00223 5.98552 3.30374 6.01518 3.57774 6.12853C3.85174 6.24187 4.08593 6.43382 4.2507 6.6801C4.41546 6.92637 4.50341 7.21591 4.50341 7.51211C4.50341 7.90929 4.34543 8.2902 4.06421 8.57105C3.783 8.8519 3.40159 9.00969 3.0039 9.00969ZM12.001 13.5024C11.7044 13.5024 11.4145 13.4146 11.1679 13.25C10.9213 13.0855 10.7291 12.8516 10.6156 12.5779C10.5021 12.3043 10.4724 12.0032 10.5303 11.7127C10.5881 11.4222 10.7309 11.1553 10.9407 10.9459C11.1504 10.7365 11.4176 10.5938 11.7084 10.536C11.9993 10.4783 12.3008 10.5079 12.5748 10.6213C12.8488 10.7346 13.083 10.9266 13.2478 11.1728C13.4125 11.4191 13.5005 11.7086 13.5005 12.0048C13.5005 12.402 13.3425 12.7829 13.0613 13.0638C12.7801 13.3446 12.3987 13.5024 12.001 13.5024Z"
                      fill="#FB018E"/>
                </svg>

                <div class="single-news-share-wrap" :class="shareOpen ? 'visible' : ''">
                  <div class="single-news-share-list">
                    <div class="single-news-share-item">
                      <a :href="`https://twitter.com/intent/tweet?url=${urlPath}`" class="single-news-share-item-link"
                         target="blank">
                        <svg width="22" height="18" viewBox="0 0 22 18" xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M21.6501 2.09396C21.1613 2.30716 20.6539 2.47535 20.1332 2.59712C20.7069 2.06088 21.1383 1.39015 21.3816 0.641499C21.4511 0.427771 21.2151 0.242956 21.0189 0.35739C20.2946 0.779991 19.5143 1.09702 18.6998 1.29977C18.6526 1.31154 18.6038 1.3175 18.5549 1.3175C18.4065 1.3175 18.2623 1.26332 18.1489 1.16497C17.2823 0.413737 16.1677 5.9573e-08 15.0106 5.9573e-08C14.5099 5.9573e-08 14.0043 0.0767647 13.508 0.228183C11.9701 0.697371 10.7834 1.94518 10.4111 3.48469C10.2714 4.06214 10.2336 4.64012 10.2986 5.20253C10.3061 5.26716 10.275 5.31227 10.2559 5.33342C10.2223 5.37051 10.1746 5.39177 10.1251 5.39177C10.1195 5.39177 10.1139 5.39151 10.1082 5.39098C6.74178 5.08334 3.70606 3.48807 1.56027 0.899069C1.45084 0.767013 1.24101 0.78321 1.15379 0.930355C0.733592 1.63944 0.511529 2.45045 0.511529 3.27571C0.511529 4.54045 1.02812 5.73233 1.92543 6.60123C1.54809 6.51322 1.18287 6.37462 0.843604 6.18928C0.679471 6.09959 0.477523 6.21487 0.475216 6.39953C0.451723 8.27839 1.57008 9.95022 3.24542 10.703C3.21168 10.7038 3.17794 10.7042 3.14415 10.7042C2.87859 10.7042 2.6097 10.679 2.34505 10.6292C2.16021 10.5945 2.00493 10.767 2.06232 10.9433C2.6061 12.6131 4.06785 13.844 5.81711 14.1235C4.36533 15.082 2.67471 15.5877 0.915104 15.5877L0.366545 15.5874C0.197531 15.5874 0.054585 15.6957 0.0115135 15.8568C-0.0309144 16.0154 0.0472366 16.1827 0.191363 16.2651C2.17415 17.4001 4.43581 18 6.73282 18C8.74345 18 10.6242 17.6075 12.3229 16.8335C13.8802 16.124 15.2564 15.1097 16.4131 13.8188C17.4907 12.6164 18.3334 11.2282 18.9176 9.69302C19.4745 8.22964 19.7689 6.66818 19.7689 5.17741V5.1064C19.7689 4.86703 19.8789 4.6418 20.0709 4.48849C20.7996 3.90655 21.4342 3.22153 21.9569 2.45246C22.0949 2.24939 21.8772 1.99488 21.6501 2.09396Z"></path>
                        </svg>
                      </a>
                    </div>
                    <div class="single-news-share-item">
                      <a :href="`https://telegram.me/share/url?url=${urlPath}`" class="single-news-share-item-link"
                         target="blank">
                        <svg width="22" height="18" viewBox="0 0 22 18" xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M8.74993 16.6443C8.11869 16.6443 8.23199 16.4015 8.00539 15.8026L6.16022 9.71682L17.6197 2.56274L18.9631 2.91883L17.8463 5.96174L8.74993 16.6443Z"></path>
                          <path
                              d="M8.75006 16.6441C9.23563 16.6441 9.44605 16.4175 9.7212 16.1585C10.142 15.7539 15.5481 10.4935 15.5481 10.4935L12.23 9.68427L9.1547 11.6265L8.75006 16.4823V16.6441Z"></path>
                          <path
                              d="M9.07375 11.6913L16.9076 17.4696C17.7978 17.9552 18.4453 17.7124 18.6719 16.6442L21.8604 1.62383C22.1842 0.312784 21.3587 -0.269901 20.5009 0.118556L1.79018 7.33738C0.511513 7.85532 0.527699 8.56749 1.56358 8.87502L6.37074 10.3803L17.4903 3.37188C18.0083 3.04817 18.4938 3.22621 18.1054 3.5823L9.07375 11.6913Z"></path>
                        </svg>
                      </a>
                    </div>
                    <div class="single-news-share-item">
                      <a :href="`https://www.linkedin.com/shareArticle?mini=true&amp;url=${urlPath}`"
                         class="single-news-share-item-link" target="blank">
                        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M18.1908 0H1.80916C0.81 0 0 0.81 0 1.80916V18.1908C0 19.19 0.81 20 1.80916 20H18.1908C19.19 20 20 19.19 20 18.1908V1.80916C20 0.81 19.19 0 18.1908 0ZM6.18885 17.2693C6.18885 17.5601 5.95314 17.7958 5.66236 17.7958H3.4212C3.13042 17.7958 2.89471 17.5601 2.89471 17.2693V7.8745C2.89471 7.58372 3.13042 7.34801 3.4212 7.34801H5.66236C5.95314 7.34801 6.18885 7.58372 6.18885 7.8745V17.2693ZM4.54178 6.46241C3.36592 6.46241 2.41267 5.50916 2.41267 4.3333C2.41267 3.15743 3.36592 2.20419 4.54178 2.20419C5.71764 2.20419 6.67089 3.15743 6.67089 4.3333C6.67089 5.50916 5.7177 6.46241 4.54178 6.46241ZM17.901 17.3117C17.901 17.5791 17.6843 17.7958 17.417 17.7958H15.012C14.7447 17.7958 14.528 17.5791 14.528 17.3117V12.905C14.528 12.2476 14.7208 10.0243 12.81 10.0243C11.3279 10.0243 11.0272 11.5461 10.9669 12.2291V17.3117C10.9669 17.5791 10.7502 17.7958 10.4828 17.7958H8.15681C7.88948 17.7958 7.67272 17.5791 7.67272 17.3117V7.83209C7.67272 7.56476 7.88948 7.34801 8.15681 7.34801H10.4828C10.7501 7.34801 10.9669 7.56476 10.9669 7.83209V8.65173C11.5164 7.82696 12.3332 7.19037 14.0722 7.19037C17.9231 7.19037 17.901 10.7881 17.901 12.7648V17.3117Z"></path>
                        </svg>
                      </a>
                    </div>
                    <div class="single-news-share-item">
                      <a :href="`https://www.facebook.com/sharer/sharer.php?url=${urlPath}`"
                         class="single-news-share-item-link" target="blank">
                        <svg width="12" height="24" viewBox="0 0 12 24" xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M7.78917 24V13.0525H11.3271L11.8568 8.786H7.78907V6.06204C7.78907 4.8268 8.11929 3.98505 9.82483 3.98505L12 3.98399V0.168096C11.6238 0.116195 10.3325 0 8.8304 0C5.69416 0 3.54703 1.98823 3.54703 5.63963V8.786H0V13.0525H3.54703V23.9999H7.78917V24Z"></path>
                        </svg>
                      </a>
                    </div>
                    <div class="single-news-share-item">
                      <a @click="copy" class="single-news-share-item-link" ref="copyLink">
                        <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M6.06802 20.9103C4.59179 19.4341 4.59179 17.0342 6.06802 15.5579L9.52117 12.1048L7.88092 10.4645L4.42777 13.9177C2.04509 16.3004 2.04509 20.1679 4.42777 22.5506C6.81044 24.9332 10.678 24.9332 13.0607 22.5506L16.5138 19.0974L14.8736 17.4572L11.4204 20.9103C9.94418 22.3865 7.54424 22.3865 6.06802 20.9103ZM10.4708 18.2341L17.3771 11.3278L15.6505 9.60125L8.74421 16.5076L10.4708 18.2341ZM13.0607 5.28481L9.6075 8.73796L11.2477 10.3782L14.7009 6.92505C16.1771 5.44883 18.5771 5.44883 20.0533 6.92505C21.5295 8.40128 21.5295 10.8012 20.0533 12.2774L16.6001 15.7306L18.2404 17.3708L21.6935 13.9177C24.0762 11.535 24.0762 7.66748 21.6935 5.28481C19.3109 2.90213 15.4433 2.90213 13.0607 5.28481Z"></path>
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="song-content-wrap">
            <div class="song-content">
              <div class="song-image-wrap">
                <div class="pm-label">
                  <div class="pending-ieo-label" v-if="song.totalPlanned">
                    <span class="pending-ieo-label-title">Minimum Funding Target</span>
                    <span class="pending-ieo-label-price" v-text="'€ ' + totalPlannedWithComas"></span>
                  </div>
                  <div class="progress-bar">
                    <div class="holder-progress-bar sold">
                      <span class="progress-title">Total {{ currencyName }}s bid for</span>
                      <span class="progress-count" v-text="soldAmount"></span>
                    </div>

                    <div class="animated-progress">
                      <span :style="{width: song.progressBarAmountRounded + '%'}"></span>
                    </div>

                    <div class="holder-progress-bar ipr-bid">
                      <span class="progress-title">Total {{ currencyName }}s offered</span>
                      <!--                      <span class="progress-count" v-text="availableAmount"></span>-->
                      <span class="progress-count">
                        {{ availableAmount }}
                        <span v-text="'(' + amountPercentForShow + '%' + ')'"></span>
                      </span>
                    </div>

                  </div>
                </div>
                <ul class="song-genre-list">
                  <li class="song-genre-list-item genre" v-text="song.songGenre"></li>
                </ul>
                <div class="pending-ieo-list-item__play-wrap">
                  <div :class="togglePlayerFlag ?
          'hitparad_button-play hitparad_button-pause'
          : 'hitparad_button-play hitparad_button-play-active'"
                       @click="toggleMusic">
                    <div class="hitparad_button-play-progress">
                      <canvas width="70" height="70"></canvas>
                      <canvas width="70" height="70"></canvas>
                    </div>
                  </div>
                </div>
                <img v-if="song.songAlbumUrlImage" :src="song.songAlbumUrlImage" alt="Artist image"
                     class="song-image" onerror="this.onerror=null;this.src='@/assets/img/default-song-image.jpg';" loading="lazy">
                <img v-else src="@/assets/img/default-song-image.jpg" alt="Artist image"
                     class="song-image artist-list-item-image-default" loading="lazy">
                <div class="audio-player-wrapper">
                  <AudioPlayer
                      :src="playerSrc"
                      :togglePlayerFlag="togglePlayerFlag"
                      :width="'100%'"
                      v-if="playerSrc"
                      :ref="`audioPlayer${identifier}${index}`"
                      @audioPause="togglePlayerFlag = true"
                      :identifier="identifier"
                      :index="index"
                  />
                </div>
              </div>

              <div class="song-about">
                <div class="song-about-video" v-if="song.videoLink !== ''">
                  <video-embed css="embed-responsive-16by9" :src="song.videoLink"></video-embed>
                </div>
                <div class="song-about-text">
                  <h2 class="song-subtitle">Song description</h2>
                  <div class="song-descr" v-if="song.description">
                    {{ descriptionOfSong }}
                    <div class="artist-profile-description-btn-wrap"
                         v-if="song.description.length > 200"
                    >

                      <button class="artist-profile-description-btn"
                              @click="openFullDescription"
                              v-if="descriptionOfSong.length <= 200"
                      >read more
                      </button>
                      <button class="artist-profile-description-btn"
                              @click="closeFullDescription"
                              v-else
                      >hide
                      </button>

                    </div>
                  </div>

                  <!--                  <div style="color: #0a8415" v-text="song.description.length"></div>-->
                </div>
              </div>

              <!--              <div class="song-about" v-if="song.description !== null">-->
              <!--                <div class="song-about-text">-->
              <!--                  <h2 class="song-subtitle" >Song description</h2>-->
              <!--                  <div class="song-descr" v-text="song.description"></div>-->
              <!--                </div>-->
              <!--              </div>-->

              <div class="song-delta-form-wrap">
                <form class="song-delta-form" v-if="song.status === 'OPEN'">
                  <div class="song-specifications">
                    <h2 class="song-subtitle">Your Bid</h2>
                    <div class="song-specifications-content" v-if="isLogged === true">
                      <div class="song-price-block-wrap">
                        <div class="song-price-block" v-if="song.ieoType === 'STANDARD'">
                          <span class="song-price-title">price:</span>
                          <div class="song-price-text">

                            <div class="song-price-value-wrap">
                              <span class="song-price-value">€</span>
                              <input class="song-price-value" name="price" type="number" v-model="formData.price"
                                     :min="song.marketPrice"
                                     readonly
                                     pattern="^\d*(\.\d{0,2})?$"
                              />
                            </div>
                            <span class="song-price-equally">
                                                                = 1 Share
                                                            </span>
                          </div>
                        </div>
                        <div class="song-price-block" v-if="song.ieoType === 'DUTCH'">
                          <span class="song-price-title">Min price per {{ currencyName }} offered</span>
                          <div class="song-price-text">
                            <div class="song-price-value-wrap">
                              <!--                              <span class="song-price-value">€</span>-->
                              <VueAutoNum
                                  ref="song-price-value-ref"
                                  v-model="formData.price"
                                  class="song-price-value"
                                  name="price"
                                  @blur.native="$v.formData.price.$touch()"
                                  :options="numParams"
                              ></VueAutoNum>
                              <!--                              <money-->
                              <!--                                  ref="song-price-value-ref"-->
                              <!--                                  v-model="formData.price"-->
                              <!--                                  v-bind="money"-->
                              <!--                                  class="song-price-value"-->
                              <!--                                  name="price"-->
                              <!--                                  @blur.native="$v.formData.price.$touch()"-->
                              <!--                              ></money>-->
                              <!--                              <input class="song-price-value" name="price" type="number" v-model="formData.price"-->
                              <!--                                     ref="song-price-value-ref"-->
                              <!--                                     @blur="$v.formData.price.$touch()"-->
                              <!--                              />-->
                              <p class="error-message"
                                 v-if="!$v.formData.price.minValue">
                                Min price can't be less then {{ numberFormattingDecimal(song.marketPrice) }}</p>
                              <p class="error-message"
                                 v-if="!$v.formData.price.required">
                                This field is required</p>
                            </div>
                            <span class="song-price-equally">= 1 {{ currencyName }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="song-delta-wrapper">
                        <div class="song-delta-wrap">

                          <div class="song-delta-container">
                            <span class="song-price-title">Number of {{ currencyName }}</span>
                            <div class="song-price-wrap">
                              <VueAutoNum
                                  v-model="formData.amount"
                                  class="song-delta-input"
                                  name="amount"
                                  @blur.native="$v.formData.amount.$touch()"
                                  :options="numParamsWithoutDecimal"
                              ></VueAutoNum>
                              <!--                              <money-->
                              <!--                                  v-model="formData.amount"-->
                              <!--                                  v-bind="moneyWithoutDecimal"-->
                              <!--                                  class="song-delta-input"-->
                              <!--                                  name="amount"-->
                              <!--                                  @blur.native="$v.formData.amount.$touch()"-->
                              <!--                              ></money>-->
                              <!--                              <input-->
                              <!--                                  type="number"-->
                              <!--                                  name="amount"-->
                              <!--                                  placeholder=""-->
                              <!--                                  class="song-delta-input"-->
                              <!--                                  ref="song-delta-input-amount"-->
                              <!--                                  step="1"-->
                              <!--                                  min="1"-->
                              <!--                                  v-model="formData.amount"-->
                              <!--                                  @blur="$v.formData.amount.$touch()"-->
                              <!--                              >-->
                              <p class="error-message"
                                 v-if="!$v.formData.amount.integer">
                                Must be integer numbers only</p>
                              <p class="error-message"
                                 v-if="!$v.formData.amount.required">
                                This field is required</p>
                              <span class="song-price-amount" v-text="'of ' + availableAmount"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--                      <div-->
                      <!--                          v-if="mongoFlag"-->
                      <!--                          id="PaylineWidget"-->
                      <!--                          :data-token="paymentUrl"-->
                      <!--                          ref="PaylineWidgetRef"-->
                      <!--                      ></div>-->
                      <div class="song-delta-total-wrap">
                        <span class="song-delta-total-title">Total</span>
                        <div class="song-delta-total">
                          <span class="song-delta-total-text" v-text="'€' + totalBidsCount"></span>
                          <button type="button" class="btn btn-hover song-delta-btn"
                                  :class="{'disabled-btn': disableBuyButton}" @click="openPopup"
                                  :disabled="disableBuyButton">
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <path
                                  d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z"
                                  fill="white"></path>
                              <path
                                  d="M12.144 14.768H10.096V11.712H7.056V9.696H10.096V6.624H12.144V9.696H15.2V11.712H12.144V14.768Z"
                                  fill="#FF0090"></path>
                            </svg>
                            <span>Buy</span>
                          </button>
                          <p class="error-message"
                             v-if="!checkValidTotalBids">
                            Total amount can’t exceed {{ '€' + numberFormattingDecimal(2400) }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="song-specifications-content-unlogin" v-if="!isLogged">
                      <span class="song-specifications-content-unlogin-title">
                        Sign In and invest in your favorite songs and receive income from streaming and other sources {{
                          currencyName
                        }}
                      </span>

                      <router-link :to="{path: '/login'}" class="btn btn-hover song-specifications-content-unlogin-btn">
                        Sign In
                      </router-link>
                    </div>
                  </div>
                </form>
              </div>

              <div class="song-info-detail">
                <div class="song-info-detail-item">
                  <div>
                    <div class="song-info-detail-auction-mob">
                      <!--                                            <h4 class="song-info-title">Auction finished</h4>-->
                      <div class="">
                        <div class="main-song-bottom-wrap" v-if="song.status === 'NOT_STARTED'">
                          <div class="song-time-block-wrapper">
                            <div class="song-time-block-wrap">
                              <h2 class="song-subtitle">Time to start</h2>
                              <div class="song-time-block">
                                <div class="pending-ieo-countdown-wrap  dark-theme-clock">
                                  <flip-countdown :deadline="timeIeoStart" :showSeconds="false"></flip-countdown>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="main-song-bottom-wrap" v-else-if="song.status === 'OPEN'">
                          <div class="song-time-block-wrapper">
                            <div class="song-time-block-wrap" v-if="song.status === 'NOT_STARTED'">
                            </div>
                            <div class="song-time-block-wrap song-time-block-end-time"
                                 v-else-if="song.status === 'OPEN'">
                              <h2 class="song-subtitle">End of auction in</h2>
                              <div class="song-time-block">
                                <div class="pending-ieo-countdown-wrap">
                                  <flip-countdown :deadline="timeIeoFinish" :showSeconds="false"></flip-countdown>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div id="chart2" v-if="song.ieoBids !== null">
                            <BidsChart :ieoBidsData="song.ieoChartBids"/>
                          </div>
                          <div class="song-current-info">
                            <div class="song-current-top">
                              <div class="song-current-min-bit">
                                <span class="song-current-min-bit-title">Current min bid per {{ currencyName }}:</span>
                                <span class="song-current-min-bit-value" v-text="'€' + minimumPricePerOne"></span>
                              </div>
                              <div class="song-current-max-bit">
                                <span class="song-current-max-bit-title">Current max bid per {{ currencyName }}:</span>
                                <span class="song-current-max-bit-value" v-text="'€' + maximumPricePerOne"></span>
                              </div>
                            </div>
                            <div class="song-current-bottom">
                              <div class="song-current-all-money">
                                <span class="song-current-all-money-title">Current bid Amount:</span>
                                <span class="song-current-all-money-value" v-text="'€' + songMoney"></span>
                              </div>
                            </div>
                          </div>

                          <div class="song-investor-table" v-if="song.ieoBids !== null"
                               :style="{opacity: titleFlag ? 1 : 0}">
                            <div class="song-investor-header">
                              <div class="song-investor-header-item">
                                User
                              </div>
                              <div class="song-investor-header-item">
                                Bid per {{ currencyName }}
                              </div>
                              <div class="song-investor-header-item">
                                {{ currencyName }}
                              </div>
                              <div class="song-investor-header-item">
                                Total (€)
                              </div>
                            </div>
                            <div class="song-investor-body">
                              <vue-custom-scrollbar class="scroll-area" :settings="scrollSettings">

                                <div class="song-investor-list">
                                  <SongIeoBids v-for="(investor, index) in songIeoBids" :key="index"
                                               :investor="investor"
                                               :currentUser="currentUser.userName"/>
                                </div>
                              </vue-custom-scrollbar>

                              <div class="song-investor-show-wrap" v-if="songIeoBids" :class="{hide: !showBids}"
                                   @click="showBidsFunc">
                                <a class="song-investor-show-more">
                                  <span>All users </span>
                                  <svg width="8" height="5" viewBox="0 0 8 5" fill="none"
                                       xmlns="http://www.w3.org/2000/svg">
                                    <path fill="#FF0090" d="M1.14258 1.06746L4.24529 3.93256L7.348 1.06746"
                                          stroke="#FF0090"
                                          stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                </a>
                              </div>
                              <div class="song-investor-hide-wrap" :class="{hide: showBids}" @click="hideBidsFunc">
                                <a class="song-investor-hide">
                                  <span>All users </span>
                                  <svg width="8" height="5" viewBox="0 0 8 5" fill="none"
                                       xmlns="http://www.w3.org/2000/svg">
                                    <path fill="#FF0090" d="M1.14258 1.06746L4.24529 3.93256L7.348 1.06746"
                                          stroke="#FF0090"
                                          stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="main-song-alert-wrap" v-else-if="song.status === 'SUCCESS'">
                          <h2 class="song-subtitle">INITIAL SALE FINISHED</h2>
                          <div class="main-song-alert main-song-alert-success">
                            <svg width="50" height="50" viewBox="0 0 50 50" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <circle cx="25" cy="25" r="24" fill="#EBF6ED" stroke="#6FAD84" stroke-width="2"/>
                              <path
                                  d="M35.3017 19.2842C35.697 18.8985 36.3301 18.9064 36.7158 19.3017C37.1015 19.697 37.0936 20.3301 36.6983 20.7158L35.3017 19.2842ZM24.7243 31L25.4226 31.7158C25.0315 32.0974 24.4064 32.0943 24.019 31.7089L24.7243 31ZM17.2947 25.0187C16.9032 24.6292 16.9016 23.996 17.2911 23.6045C17.6806 23.213 18.3138 23.2114 18.7053 23.6009L17.2947 25.0187ZM36.6983 20.7158L25.4226 31.7158L24.026 30.2842L35.3017 19.2842L36.6983 20.7158ZM24.019 31.7089L17.2947 25.0187L18.7053 23.6009L25.4296 30.2911L24.019 31.7089Z"
                                  fill="#6FAD84"/>
                            </svg>
                            <span>The Initial Sale is successful</span>
                          </div>

                          <div class="song-winner-list-wrapper">
                            <h4 class="song-subtitle">Final price per {{ currencyName }} <span
                                class="song-winner-list-final_price" v-text="'€' + songClosedByPrice"></span></h4>
                            <ul class="song-winners-list">
                              <li class="song-winners-item top">
                                <div class="song-winners-item-left">User</div>
                                <div class="song-winners-item-right">
                                  <div class="song-winners-item-right__bid">Bid per {{ currencyName }}</div>
                                  <div class="song-winners-item-right__amount">{{ currencyName }}</div>
                                </div>
                              </li>
                              <vue-custom-scrollbar class="scroll-area" :settings="scrollSettings">
                                <div class="song-winners-item-wrapper">
                                  <SongWinnersList v-for="(ieo, index) in songIeoBids" :key='index' :ieo="ieo" ref="qwerty"/>
                                </div>
                              </vue-custom-scrollbar>

                              <div class="song-investor-show-wrap" v-if="songIeoBids.length" :class="{hide: !showBids}"
                                   @click="showBidsFunc">
                                <a class="song-investor-show-more">
                                  <span>All users </span>
                                  <svg width="8" height="5" viewBox="0 0 8 5" fill="none"
                                       xmlns="http://www.w3.org/2000/svg">
                                    <path fill="#FF0090" d="M1.14258 1.06746L4.24529 3.93256L7.348 1.06746"
                                          stroke="#FF0090"
                                          stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                </a>
                              </div>
                              <div class="song-investor-hide-wrap" :class="{hide: showBids}" @click="hideBidsFunc">
                                <a class="song-investor-hide">
                                  <span>All users </span>
                                  <svg width="8" height="5" viewBox="0 0 8 5" fill="none"
                                       xmlns="http://www.w3.org/2000/svg">
                                    <path fill="#FF0090" d="M1.14258 1.06746L4.24529 3.93256L7.348 1.06746"
                                          stroke="#FF0090"
                                          stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
                                  </svg>
                                </a>
                              </div>
                            </ul>
                          </div>
                        </div>
                        <div class="main-song-alert-wrap" v-else-if="song.status === 'FAILED'">
                          <h2 class="song-subtitle">INITIAL SALE FINISHED</h2>
                          <div class="main-song-alert main-song-alert-danger">
                            <svg width="50" height="50" viewBox="0 0 50 50" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <circle cx="25" cy="25" r="24" fill="#FFF4F4" stroke="#E25E5E" stroke-width="2"/>
                              <path
                                  d="M32.2929 17.2929C32.6834 16.9024 33.3166 16.9024 33.7071 17.2929C34.0976 17.6834 34.0976 18.3166 33.7071 18.7071L32.2929 17.2929ZM18.7071 33.7071C18.3166 34.0976 17.6834 34.0976 17.2929 33.7071C16.9024 33.3166 16.9024 32.6834 17.2929 32.2929L18.7071 33.7071ZM33.7071 18.7071L18.7071 33.7071L17.2929 32.2929L32.2929 17.2929L33.7071 18.7071Z"
                                  fill="#E25E5E"/>
                              <path
                                  d="M33.7071 32.2929C34.0976 32.6834 34.0976 33.3166 33.7071 33.7071C33.3166 34.0976 32.6834 34.0976 32.2929 33.7071L33.7071 32.2929ZM17.2929 18.7071C16.9024 18.3166 16.9024 17.6834 17.2929 17.2929C17.6834 16.9024 18.3166 16.9024 18.7071 17.2929L17.2929 18.7071ZM32.2929 33.7071L17.2929 18.7071L18.7071 17.2929L33.7071 32.2929L32.2929 33.7071Z"
                                  fill="#E25E5E"/>
                            </svg>
                            <span>Not successful</span>
                          </div>
                          <ul class="song-winners-list">
                            <li class="song-winners-item top">
                              <div class="song-winners-item-left">User</div>
                              <div class="song-winners-item-right">
                                <div class="song-winners-item-right__bid">Bid per {{ currencyName }}</div>
                                <div class="song-winners-item-right__amount">{{ currencyName }}</div>
                              </div>
                            </li>
                            <vue-custom-scrollbar class="scroll-area" :settings="scrollSettings">
                              <div class="song-winners-item-wrapper">
                                <SongWinnersList v-for="(ieo, index) in songIeoBids" :key='index' :ieo="ieo"/>
                              </div>
                            </vue-custom-scrollbar>

                            <div class="song-investor-show-wrap" v-if="songIeoBids.length" :class="{hide: !showBids}"
                                 @click="showBidsFunc">
                              <a class="song-investor-show-more">
                                <span>All users </span>
                                <svg width="8" height="5" viewBox="0 0 8 5" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                  <path fill="#FF0090" d="M1.14258 1.06746L4.24529 3.93256L7.348 1.06746"
                                        stroke="#FF0090"
                                        stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </a>
                            </div>
                            <div class="song-investor-hide-wrap" :class="{hide: showBids}" @click="hideBidsFunc">
                              <a class="song-investor-hide">
                                <span>All users </span>
                                <svg width="8" height="5" viewBox="0 0 8 5" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                  <path fill="#FF0090" d="M1.14258 1.06746L4.24529 3.93256L7.348 1.06746"
                                        stroke="#FF0090"
                                        stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </a>
                            </div>
                          </ul>
                        </div>
                      </div>
                    </div>

                  </div>
                  <h4 class="song-info-title">Funds will be used for:</h4>

                  <div class="song-info-used">
                    <div class="song-info-used-list">
                      <div class="song-info-used-item">
                        <span class="song-info-used-item-title">Administrator</span>
                        <div class="song-info-used-item-value-wrap admin-wrap" v-if="song.ieoAdminType">
                          <span class="song-info-used-item-value">{{ song.ieoAdminType.publicName }}</span>
                        </div>
                      </div>
                      <div class="song-info-used-item">
                        <span class="song-info-used-item-title">Marketing:</span>
                        <div class="song-info-used-item-value-wrap">
                          <span class="song-info-used-item-descr" v-if="song.purposeTypeMap.marketingUse.purposeName">{{
                              `${song.purposeTypeMap.marketingUse.purposeName}:`
                            }}</span>
                          <span class="song-info-used-item-value" v-text="'€' + marketing"></span>
                        </div>
                      </div>
                      <div class="song-info-used-item">
                        <span class="song-info-used-item-title">Audio Production:</span>
                        <div class="song-info-used-item-value-wrap">
                          <span class="song-info-used-item-descr" v-if="song.purposeTypeMap.songProduction.purposeName">{{
                              `${song.purposeTypeMap.songProduction.purposeName}:`
                            }}</span>
                          <span class="song-info-used-item-value" v-text="'€' + audio"></span>
                        </div>
                      </div>
                      <div class="song-info-used-item">
                        <span class="song-info-used-item-title">Video Production:</span>
                        <div class="song-info-used-item-value-wrap">
                          <span class="song-info-used-item-descr"
                                v-if="song.purposeTypeMap.videoProduction.purposeName">{{
                              `${song.purposeTypeMap.videoProduction.purposeName}:`
                            }}</span>
                          <span class="song-info-used-item-value" v-text="'€' + video"></span>
                        </div>
                      </div>
                      <div class="song-info-used-item" v-if="song.purposeTypeMap.tourProduction">
                        <span class="song-info-used-item-title">Tour Production:</span>
                        <div class="song-info-used-item-value-wrap">
                          <span class="song-info-used-item-descr"
                                v-if="song.purposeTypeMap.tourProduction.purposeName">{{
                              `${song.purposeTypeMap.tourProduction.purposeName}:`
                            }}</span>
                          <span class="song-info-used-item-value" v-text="'€' + tour"></span>
                        </div>
                      </div>
                      <div class="song-info-used-item">
                        <span class="song-info-used-item-title">Private use:</span>
                        <div class="song-info-used-item-value-wrap">

                          <span class="song-info-used-item-descr" v-if="song.purposeTypeMap.privateUse.purposeName">{{
                              `${song.purposeTypeMap.privateUse.purposeName}:`
                            }}</span>

                          <span class="song-info-used-item-value" v-text="'€' + privat"></span>
                        </div>
                      </div>
                      <div class="song-info-used-item">
                        <span class="song-info-used-item-title">Commission: </span>
                        <div class="song-info-used-item-value-wrap commission">
                          <span class="song-info-used-item-value" v-text="'€' + commissionAmount"></span>
                        </div>
                      </div>

                    </div>
                    <div class="song-info-used-sum-wrap">
                      <div class="song-info-used-total">
                        Total funds
                      </div>
                      <span class="song-info-used-sum" v-text="'€' + totalPlannedWithComas"></span>
                    </div>
                  </div>
                </div>
                <!--                <div class="song-info-detail-item">-->
                <!--                  <h4 class="song-info-title">Song</h4>-->
                <!--                  <div class="song-info-songs">-->
                <!--                    <div class="song-info-songs-item">-->
                <!--                      <span class="song-info-songs-item-title">Streams</span>-->
                <!--                      <span class="song-info-songs-item-value"-->
                <!--                            v-text="'1,616'"></span>-->
                <!--                    </div>-->
                <!--                    <div class="song-info-songs-item">-->
                <!--                      <span class="song-info-songs-item-title">Song shared</span>-->
                <!--                      <span class="song-info-songs-item-value"-->
                <!--                            v-text="'109'"></span>-->
                <!--                    </div>-->
                <!--                    <div class="song-info-songs-item song-info-songs-item-response">-->
                <!--                      <span class="song-info-songs-item-title">Achievements</span>-->
                <!--                      <span class="song-info-songs-item-value responsive-info-value">Djooky Music Awards Global Round finalist, Winter Edition</span>-->
                <!--                    </div>-->
                <!--                  </div>-->
                <!--                </div>-->

              </div>

              <!--              <div v-if="isLogged === true">-->
              <!--                <div class="song-btn-wrap">-->

              <!--&lt;!&ndash;                  <div class="song-subscribe-btn-wrap"&ndash;&gt;-->
              <!--&lt;!&ndash;                       :style="{'justify-content': song.status !== 'SUCCESS' ? 'space-between' : 'center'}"&ndash;&gt;-->
              <!--&lt;!&ndash;                  >&ndash;&gt;-->
              <!--&lt;!&ndash;                    <div class="song-subscribe-btn-item">&ndash;&gt;-->
              <!--&lt;!&ndash;                      <a @click="followAll"&ndash;&gt;-->
              <!--&lt;!&ndash;                         class="btn btn-transparent song-subscribe-btn"&ndash;&gt;-->
              <!--&lt;!&ndash;                         v-if="song.subscribedSinger === false">Follow artist</a>&ndash;&gt;-->

              <!--&lt;!&ndash;                      <a @click="unfollowAll"&ndash;&gt;-->
              <!--&lt;!&ndash;                         class="btn btn-transparent song-subscribe-btn"&ndash;&gt;-->
              <!--&lt;!&ndash;                         v-if="song.subscribedSinger === true">Unfollow artist</a>&ndash;&gt;-->
              <!--&lt;!&ndash;                    </div>&ndash;&gt;-->

              <!--&lt;!&ndash;                    <div class="song-subscribe-btn-item" v-if="song.status !== 'SUCCESS'">&ndash;&gt;-->
              <!--&lt;!&ndash;                      <a class="btn btn-hover song-subscribe-all-btn"&ndash;&gt;-->
              <!--&lt;!&ndash;                         @click="followIeo"&ndash;&gt;-->
              <!--&lt;!&ndash;                         v-if="song.subscribedIeo === false"&ndash;&gt;-->
              <!--&lt;!&ndash;                      >Follow to Initial Sales</a>&ndash;&gt;-->
              <!--&lt;!&ndash;                      <a class="btn btn-hover song-subscribe-all-btn"&ndash;&gt;-->
              <!--&lt;!&ndash;                         @click="unfollowIeo"&ndash;&gt;-->
              <!--&lt;!&ndash;                         v-if="song.subscribedIeo === true"&ndash;&gt;-->
              <!--&lt;!&ndash;                      >Unfollow from Initial Sales</a>&ndash;&gt;-->
              <!--&lt;!&ndash;                    </div>&ndash;&gt;-->
              <!--&lt;!&ndash;                  </div>&ndash;&gt;-->
              <!--                </div>-->
              <!--              </div>-->
            </div>
            <div class="main-song-sidebar">
              <div class="song-info-detail-auction-descktop">
                <div class="">
                  <div class="main-song-bottom-wrap" v-if="song.status === 'NOT_STARTED'">
                    <div class="song-time-block-wrapper">
                      <div class="song-time-block-wrap">
                        <h2 class="song-subtitle">Time to start</h2>
                        <div class="song-time-block">
                          <div class="pending-ieo-countdown-wrap dark-theme-clock">
                            <flip-countdown :deadline="timeIeoStart" :showSeconds="false"
                                            v-if="timeIeoStart"></flip-countdown>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="main-song-bottom-wrap" v-else-if="song.status === 'OPEN'">
                    <div class="song-time-block-wrapper">
                      <div class="song-time-block-wrap" v-if="song.status === 'NOT_STARTED'">
                      </div>
                      <div class="song-time-block-wrap song-time-block-end-time" v-else-if="song.status === 'OPEN'">
                        <h2 class="song-subtitle">End of auction in</h2>
                        <div class="song-time-block">
                          <div class="pending-ieo-countdown-wrap">
                            <flip-countdown :deadline="timeIeoFinish" :showSeconds="false"
                                            v-if="timeIeoFinish"></flip-countdown>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="chart" v-if="song.ieoBids !== null">
                      <BidsChart :ieoBidsData="song.ieoChartBids"/>
                    </div>
                    <div class="song-current-info">
                      <div class="song-current-top">
                        <div class="song-current-min-bit">
                          <span class="song-current-min-bit-title">Current min bid per {{ currencyName }}:</span>
                          <span class="song-current-min-bit-value" v-text="'€' + minimumPricePerOne"></span>
                        </div>
                        <div class="song-current-max-bit">
                          <span class="song-current-max-bit-title">Current max bid per {{ currencyName }}:</span>
                          <span class="song-current-max-bit-value" v-text="'€' + maximumPricePerOne"></span>
                        </div>
                      </div>
                      <div class="song-current-bottom">
                        <div class="song-current-all-money">
                          <span class="song-current-all-money-title">Current bid Amount:</span>
                          <span class="song-current-all-money-value" v-text="'€' + songMoney"></span>
                        </div>
                      </div>
                    </div>

                    <div class="song-investor-table" v-if="song.ieoBids !== null" :style="{opacity: titleFlag ? 1 : 0}">
                      <div class="song-investor-header">
                        <div class="song-investor-header-item">
                          User
                        </div>
                        <div class="song-investor-header-item">
                          Bid per RR
                        </div>
                        <div class="song-investor-header-item">
                          RR
                        </div>
                        <div class="song-investor-header-item">
                          Total (€)
                        </div>
                      </div>
                      <div class="song-investor-body">
                        <vue-custom-scrollbar class="scroll-area" :settings="scrollSettings">

                          <div class="song-investor-list">
                            <SongIeoBids v-for="(investor, index) in songIeoBids" :key="index" :investor="investor"
                                         :currentUser="currentUser.userName"/>
                          </div>
                        </vue-custom-scrollbar>
                        <div class="song-investor-show-wrap" v-if="songIeoBids" :class="{hide: !showBids}"
                             @click="showBidsFunc">
                          <a class="song-investor-show-more">
                            <span>All users </span>
                            <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill="#FF0090" d="M1.14258 1.06746L4.24529 3.93256L7.348 1.06746" stroke="#FF0090"
                                    stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </a>
                        </div>
                        <div class="song-investor-hide-wrap" :class="{hide: showBids}" @click="hideBidsFunc">
                          <a class="song-investor-hide">
                            <span>All users </span>
                            <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill="#FF0090" d="M1.14258 1.06746L4.24529 3.93256L7.348 1.06746" stroke="#FF0090"
                                    stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="main-song-alert-wrap" v-else-if="song.status === 'SUCCESS'">
                    <h4 class="song-subtitle">INITIAL SALE FINISHED</h4>
                    <div class="main-song-alert main-song-alert-success">
                      <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="25" cy="25" r="24" fill="#EBF6ED" stroke="#6FAD84" stroke-width="2"/>
                        <path
                            d="M35.3017 19.2842C35.697 18.8985 36.3301 18.9064 36.7158 19.3017C37.1015 19.697 37.0936 20.3301 36.6983 20.7158L35.3017 19.2842ZM24.7243 31L25.4226 31.7158C25.0315 32.0974 24.4064 32.0943 24.019 31.7089L24.7243 31ZM17.2947 25.0187C16.9032 24.6292 16.9016 23.996 17.2911 23.6045C17.6806 23.213 18.3138 23.2114 18.7053 23.6009L17.2947 25.0187ZM36.6983 20.7158L25.4226 31.7158L24.026 30.2842L35.3017 19.2842L36.6983 20.7158ZM24.019 31.7089L17.2947 25.0187L18.7053 23.6009L25.4296 30.2911L24.019 31.7089Z"
                            fill="#6FAD84"/>
                      </svg>
                      <span>The Initial Sale is successful</span>
                    </div>
                    <div class="song-winner-list-wrapper">
                      <h4 class="song-subtitle">Final price per {{ currencyName }} <span
                          class="song-winner-list-final_price"
                          v-text="'€' + songClosedByPrice"></span>
                      </h4>
                      <ul class="song-winners-list">
                        <li class="song-winners-item top">
                          <div class="song-winners-item-left">User</div>
                          <div class="song-winners-item-right">
                            <div class="song-winners-item-right__bid">Bid per {{ currencyName }}</div>
                            <div class="song-winners-item-right__amount">{{ currencyName }}</div>
                          </div>
                        </li>
                        <vue-custom-scrollbar class="scroll-area" :settings="scrollSettings">
                          <div class="song-winners-item-wrapper">
                            <SongWinnersList v-for="(ieo, index) in songIeoBids" :key='index' :ieo="ieo"/>
                          </div>
                        </vue-custom-scrollbar>

                        <div class="song-investor-show-wrap" v-if="songIeoBids.length" :class="{hide: !showBids}"
                             @click="showBidsFunc">
                          <a class="song-investor-show-more">
                            <span>All users </span>
                            <svg width="8" height="5" viewBox="0 0 8 5" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <path fill="#FF0090" d="M1.14258 1.06746L4.24529 3.93256L7.348 1.06746"
                                    stroke="#FF0090"
                                    stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </a>
                        </div>
                        <div class="song-investor-hide-wrap" :class="{hide: showBids}" @click="hideBidsFunc">
                          <a class="song-investor-hide">
                            <span>All users </span>
                            <svg width="8" height="5" viewBox="0 0 8 5" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                              <path fill="#FF0090" d="M1.14258 1.06746L4.24529 3.93256L7.348 1.06746"
                                    stroke="#FF0090"
                                    stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </a>
                        </div>
                      </ul>
                    </div>
                  </div>
                  <div class="main-song-alert-wrap" v-else-if="song.status === 'FAILED'">
                    <h4 class="song-subtitle">INITIAL SALE FINISHED</h4>
                    <div class="main-song-alert main-song-alert-danger">
                      <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="25" cy="25" r="24" fill="#FFF4F4" stroke="#E25E5E" stroke-width="2"/>
                        <path
                            d="M32.2929 17.2929C32.6834 16.9024 33.3166 16.9024 33.7071 17.2929C34.0976 17.6834 34.0976 18.3166 33.7071 18.7071L32.2929 17.2929ZM18.7071 33.7071C18.3166 34.0976 17.6834 34.0976 17.2929 33.7071C16.9024 33.3166 16.9024 32.6834 17.2929 32.2929L18.7071 33.7071ZM33.7071 18.7071L18.7071 33.7071L17.2929 32.2929L32.2929 17.2929L33.7071 18.7071Z"
                            fill="#E25E5E"/>
                        <path
                            d="M33.7071 32.2929C34.0976 32.6834 34.0976 33.3166 33.7071 33.7071C33.3166 34.0976 32.6834 34.0976 32.2929 33.7071L33.7071 32.2929ZM17.2929 18.7071C16.9024 18.3166 16.9024 17.6834 17.2929 17.2929C17.6834 16.9024 18.3166 16.9024 18.7071 17.2929L17.2929 18.7071ZM32.2929 33.7071L17.2929 18.7071L18.7071 17.2929L33.7071 32.2929L32.2929 33.7071Z"
                            fill="#E25E5E"/>
                      </svg>
                      <span>Not successful</span>
                    </div>
                    <ul class="song-winners-list">
                      <li class="song-winners-item top">
                        <div class="song-winners-item-left">User</div>
                        <div class="song-winners-item-right">
                          <div class="song-winners-item-right__bid">Bid per {{ currencyName }}</div>
                          <div class="song-winners-item-right__amount">{{ currencyName }}</div>
                        </div>
                      </li>
                      <vue-custom-scrollbar class="scroll-area" :settings="scrollSettings">
                        <div class="song-winners-item-wrapper">
                          <SongWinnersList v-for="(ieo, index) in songIeoBids" :key='index' :ieo="ieo"/>
                        </div>
                      </vue-custom-scrollbar>

                      <div class="song-investor-show-wrap" v-if="songIeoBids.length" :class="{hide: !showBids}"
                           @click="showBidsFunc">
                        <a class="song-investor-show-more">
                          <span>All users </span>
                          <svg width="8" height="5" viewBox="0 0 8 5" fill="none"
                               xmlns="http://www.w3.org/2000/svg">
                            <path fill="#FF0090" d="M1.14258 1.06746L4.24529 3.93256L7.348 1.06746"
                                  stroke="#FF0090"
                                  stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </a>
                      </div>
                      <div class="song-investor-hide-wrap" :class="{hide: showBids}" @click="hideBidsFunc">
                        <a class="song-investor-hide">
                          <span>All users </span>
                          <svg width="8" height="5" viewBox="0 0 8 5" fill="none"
                               xmlns="http://www.w3.org/2000/svg">
                            <path fill="#FF0090" d="M1.14258 1.06746L4.24529 3.93256L7.348 1.06746"
                                  stroke="#FF0090"
                                  stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </a>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
      <verification-message-popup ref="verificationPopup"/>
      <DisclaimerPmPopup ref="disclaimerPopup" @confirmDisclaimer="confirmDisclaimer" :contractType="contractType"/>
      <ServerErrorPopup ref="serverErrorPopup" :errorMessage="errors.followError"/>
      <ConfirmPopupForPM
          ref="confirmPopupRef"
          :song="song"
          :singerName="singerName"
          :userBid="formData"
          :userBidTotal="totalBids"
          :songDelta="+formData.amount"
          @confirmAction="confirmActionEvent"
      />

      <ConfirmPopupForBuyPM
          :song="song"
          :singerName="singerName"
          :userBid="formData"
          :userBidTotal="totalBids"
          :songDelta="+formData.amount"
          :paymentFee="paymentFee"
          ref="confirmPopupForCreatePM"
          @confirmWithCard="agreedWithCard"
          @confirmWithWallet="agreedWithWallet"
      />

      <MangopayCallErrorPopup
          ref="mangopayCallErrorPopup"
      />

    </main>
    <div class="preloader-wrapper" v-else>
      <v-progress-circular
          :size="75"
          :width="8"
          color="#FF0090"
          indeterminate
      ></v-progress-circular>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from "../header/Header";
import Footer from "../footer/Footer";
import FlipCountdown from 'vue2-flip-countdown'
import SongIeoBids from "./SongIeoBids";
import ConfirmPopupForPM from '../popups/ConfirmPopupForPM'
import BidsChart from "../chart/BidsChart";
import ServerErrorPopup from "../popups/ServerErrorPopup";
import DisclaimerPmPopup from "../popups/DisclaimerPmPopup";
import VerificationMessagePopup from "../popups/VerificationMessagePopup";
import ConfirmPopupForBuyPM from "../popups/ConfirmPopupForBuyPM";
import MangopayCallErrorPopup from "../popups/MangopayCallErrorPopup";
import SongWinnersList from "./SongWinnersList";
import {mapGetters} from 'vuex'
import moment from "moment";
import {integer, minValue, maxValue, required} from "vuelidate/lib/validators";
import numberFormattingDecimal from "../../mixins/numberCurrencyConverter";
import numberFormattingInteger from "../../mixins/numberConverter";
import scrollToElement from "@/mixins/scrollToElement";
import nameHandler from "@/mixins/nameHandler";
import AudioPlayer from "@/components/AudioPlayer";


export default {
  name: "Song",
  data() {
    return {
      currencyName: process.env.VUE_APP_CURRENCY_NAME_SHORT,
      contractType: '',
      screenWidthFlag: '',
      singerName: '',
      descriptionOfSong: '',
      disableButtonRequestPayment: false,
      mongoFlag: false,
      paymentUrl: null,
      timeIeoStart: null,
      timeIeoFinish: null,
      formDataPrice: null,
      shareOpen: false,
      song: null,
      singerUsername: '',
      songId: this.$route.params.id,
      titleFlag: false,
      togglePlayerFlag: true,
      totalForUse: 0,
      songIeoBids: [],
      coAuthorsList: [],
      coAuthorsListOpen: false,
      userAddressAndBankDetails: {},
      showBids: true,
      checkOwner: null,
      KYCStatus: null,
      paymentFee: null,
      purchaseData: null,
      // totalBids: this.totalBidsCount,
      numParams: {
        modifyValueOnWheel: false, // turn off wheel mode
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalPlaces: 2,
        currencySymbolPlacement: 'p', // prefix || suffix
        currencySymbol: '€\u00a0',
        overrideMinMaxLimits: null,
        minimumValue: '0',
        maximumValue: '1000000000',
      },
      numParamsWithoutDecimal: {
        modifyValueOnWheel: false, // turn off wheel mode
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalPlaces: 0,
        currencySymbolPlacement: 'p', // prefix || suffix
        currencySymbol: `${this.currencyName}\u00a0`,
        overrideMinMaxLimits: null,
        minimumValue: '0',
        maximumValue: '1000000000',
      },
      scrollSettings: {
        suppressScrollY: false,
        suppressScrollX: false,
        wheelPropagation: false,
        swipeEasing: true,
        wheelSpeed: 0.6
      },
      formData: {
        amount: 1,
        price: 0,
        ieoUuid: this.$route.params.id,
        paymentGoal: 'TRADE_PM',
        paymentType: ''
      },
      // amountOldValue: null,
      totalPlannedWithComas: null,
      minimumPricePerOne: null,
      maximumPricePerOne: null,
      songMoney: null,
      songClosedByPrice: null,
      marketing: null,
      audio: null,
      video: null,
      tour: null,
      privat: null,
      urlPath: '',
      mp3: '',
      errors: {
        followError: ''
      },
      range: 0,
      playEvent: null,
      songDuration: 0,
      identifier: 'songPage',
      index: 0,
      playerSrc: null
    }
  },
  validations() {
    return {
      formData: {
        amount: {
          integer,
          required
        },
        price: {
          minValue: minValue(this.song.marketPrice),
          // maxValue: maxValue(2400),
          required
        },
      },
      // totalBidsCount: {
      //   maxValue: maxValue(2400),
      // }
    }
  },
  mixins: [numberFormattingDecimal, numberFormattingInteger, scrollToElement, nameHandler],
  computed: {
    ...mapGetters({
      currentUser: 'user/getUser',
      isLogged: 'authentication/isLogged',
    }),
    totalBids() {
      return this.formData.amount * this.formData.price
    },
    totalBidsCount() {
      let sum = this.formData.amount * this.formData.price
      return this.numberFormattingDecimal(sum)
    },
    checkValidTotalBids() {
      let sum = this.formData.amount * this.formData.price
      return sum <= 2400
    },
    disableBuyButton() {
      return (this.formData.amount > this.song.availableAmount)
          || (this.disableButtonRequestPayment)
          || this.$v.$invalid
          || !this.checkValidTotalBids
    },
    commissionAmount() {
      let sum = (this.song.purposeTypeMap.marketingUse.value * 100) + (this.song.purposeTypeMap.songProduction.value * 100) + (this.song.purposeTypeMap.videoProduction.value * 100) + (this.song.purposeTypeMap.privateUse.value * 100) + (this.song.purposeTypeMap.tourProduction ? (this.song.purposeTypeMap.tourProduction.value * 100) : 0)
      let commission = (this.song.totalPlanned * 100 - sum) / 100
      return this.numberFormattingDecimal(commission)
    },
    availableAmount() {
      return this.numberFormattingInteger(this.song.availableAmount)
    },
    amountPercentForShow() {
      return this.numberFormattingDecimal(this.song.availableAmount / 1000)
    },
    soldAmount() {
      return this.numberFormattingInteger(this.song.soldAmount)
    },
    toggleTooltipShowEvent() {
      return this.screenWidthFlag === 'desktop'
    },
  },
  watch: {},
  methods: {
    screenWidthCheck() {
      if (window.innerWidth > 1200) {
        this.screenWidthFlag = 'desktop'
        return
      }
      if (window.innerWidth <= 1200) {
        this.screenWidthFlag = 'mobile'
      }
    },
    lengthWatcher() {
      window.addEventListener("resize", () => {
        if (window.innerWidth > 1200) {
          this.screenWidthFlag = 'desktop'
          return
        }
        if (window.innerWidth <= 1200) {
          this.screenWidthFlag = 'mobile'
        }
      }, false);
    },
    parseData(song) {
      this.closeFullDescription()

      if (song.timeIeoFinish) {
        let convertTimeToLocal = moment.utc(song.timeIeoFinish).local()
        let resultTimeDate = moment(String(convertTimeToLocal)).format('yyyy-MM-DD HH:mm')
        this.timeIeoFinish = resultTimeDate
      }
      if (song.timeIeoStart) {
        let convertTimeToLocal = moment.utc(song.timeIeoStart).local()
        let resultTimeDate = moment(String(convertTimeToLocal)).format('yyyy-MM-DD HH:mm')
        this.timeIeoStart = resultTimeDate
      }

      this.formData.price = song.marketPrice
      this.coAuthorsList = song.coauthors
      this.singerUsername = song.singerUsername
      this.singerName = this.getNameDefault(song.companyName, song.stageName, song.singerFirstName, song.singerLastName)

      this.totalPlannedWithComas = this.numberFormattingDecimal(song.totalPlanned)
      this.marketing = this.numberFormattingDecimal(song.purposeTypeMap.marketingUse.value)
      this.audio = this.numberFormattingDecimal(song.purposeTypeMap.songProduction.value)
      this.video = this.numberFormattingDecimal(song.purposeTypeMap.videoProduction.value)
      this.tour = song.purposeTypeMap.tourProduction ? this.numberFormattingDecimal(song.purposeTypeMap.tourProduction.value) : 0
      this.privat = this.numberFormattingDecimal(song.purposeTypeMap.privateUse.value)
      this.minimumPricePerOne = this.numberFormattingDecimal(song.minPricePerOne)
      this.maximumPricePerOne = this.numberFormattingDecimal(song.maxPricePerOne)
      this.songMoney = this.numberFormattingDecimal(song.money)
      this.songClosedByPrice = this.numberFormattingDecimal(song.closedByPrice)

      this.totalForUse = this.calcTotalForUse()

      if (song.ieoBids !== null) {
        this.songIeoBids = song.ieoBids.slice(0, 10)
      }

      this.mp3 = song.songUrlFile
      this.playerSrc = this.mp3
      this.titleFlag = true
    },
    finalPricePerBid() {
      let filteredArr = this.song.ieoBids.filter(arrayObj => arrayObj.winner === true)
      if (filteredArr) {
        return filteredArr[filteredArr.length - 1].bidPerIpr
      }
    },
    // ...mapActions({
    //   updateMoney: 'money/updateMoney'
    // }),
    // onlyNumberCheck(event) {
    //   if (event.key === ',' || event.key === '.') {
    //     this.formData.amount = 1
    //   }
    // },
    agreedWithCard() {
      this.formData.paymentType = 'CARD'
      this.$refs.confirmPopupForCreatePM.closePopup()
      this.buyIeo()
    },
    agreedWithWallet() {
      this.formData.paymentType = 'TRANSFER'
      this.$refs.confirmPopupForCreatePM.closePopup()
      this.$load(async () => {
        let res = (await this.$api.payment.getPayment(this.formData))
        // await this.$api.payment.getPayment(this.formData)
        // await this.$router.push({path: '/auction/success'})
        if (res.data.body.status === 'HOLD') {
          await this.$router.push({
            path: `/internal-payment-handler/${this.$route.params.id}`,
            query: {redirectFrom: 'initialSale', status: 'HOLD'}
          })
        } else if (res.data.body.status !== 'HOLD' && res.data.body.status !== 'PAY_AWAITING') {
          await this.$router.push({
            path: `/internal-payment-handler/${this.$route.params.id}`,
            query: {redirectFrom: 'initialSale', status: 'FAILED'}
          })
        }
      }, error => {
        if (error.data.errors[0].id === "HTTP_MESSAGE_NOT_READABLE" || error.data.errors[0].id === 'ILLEGAL_FORMAT_EXCEPTION' || error.data.errors[0].id === 'DATA_INTEGRITY_VIOLATION') {
          this.errors.followError = 'Data is not valid'
          this.$refs.serverErrorPopup.openPopups()
          return
        }
        this.errors.followError = error.data.errors[0].message
        this.$refs.serverErrorPopup.openPopups()
      })

    },
    imgOnError() {
      this.song.authorPhotoUrl = false
    },
    calcTotalForUse() {
      let sum = this.song.purposeTypeMap.marketingUse.value + this.song.purposeTypeMap.songProduction.value + this.song.purposeTypeMap.videoProduction.value + this.song.purposeTypeMap.privateUse.value + this.song.purposeTypeMap.tourProduction ? this.song.purposeTypeMap.tourProduction.value : 0
      // return new Intl.NumberFormat().format(sum)
      return sum.toFixed(2)
    },
    copy() {
      const dummy = document.createElement('input'),
          text = window.location.href;

      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
    },
    async openPopup() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      } else {
        if (!this.checkOwner) {
          if (this.KYCStatus !== 'APPROVED') {
            this.$refs.verificationPopup.openPopups()
          } else if (this.totalBids >= 1) {
            this.disableButtonRequestPayment = true
            const params = {
              ieoUuid: this.$route.params.id
            }
            this.contractType = (await this.$api.contract.getInitialContract(params)).data.body.htmlTemplate
            this.$refs.disclaimerPopup.openPopups()
            this.disableButtonRequestPayment = false
            setTimeout(() => {
              this.$refs.disclaimerPopup.changeStylesForPages()
            }, 1000)
          } else {
            this.errors.followError = 'Total price can not be less 1.00 €.'
            this.$refs.serverErrorPopup.openPopups()
          }
        } else {
          this.errors.followError = "Owner can't buy from himself"
          this.$refs.serverErrorPopup.openPopups()
        }
      }
    },
    confirmDisclaimer() {
      let params = {
        ieoUuid: this.$route.params.id
      }
      this.$load(async () => {
        this.$api.contract.initialContract(params).then(() => {
          this.$refs.disclaimerPopup.resetState()
          this.$refs.confirmPopupRef.openPopups()
        })
      })

    },
    showBidsFunc() {
      this.showBids = false
      this.songIeoBids = this.song.ieoBids.slice(0, 1000)
    },
    hideBidsFunc() {
      this.songIeoBids = this.song.ieoBids.slice(0, 10)
      this.showBids = true
    },
    // setFavorite() {
    //   if (this.song.favorite === true) {
    //     this.$load(async () => {
    //       this.$api.favorites.unfavorite(this.songId)
    //       setTimeout(() => {
    //         this.dataRequest()
    //
    //       }, 100)
    //     })
    //   } else {
    //     this.$load(async () => {
    //       this.$api.favorites.favorite(this.songId)
    //       setTimeout(() => {
    //         this.dataRequest()
    //
    //       }, 100)
    //     })
    //   }
    // },
    dataRequest() {
      if (this.isLogged) {
        this.$load(async () => {
          this.titleFlag = false
          this.song = (await this.$api.ieoSong.getSongAuth(this.songId)).data.body
          this.parseData(this.song)
          this.KYCStatus = (await this.$api.kyc.getAuthStatus()).data.body
          // this.userAddressAndBankDetails = (await this.$api.ieoSong.getBankAndAddressDetails(this.song.singerId)).data.body
        })
      } else {
        this.$load(async () => {
          this.titleFlag = false
          this.song = (await this.$api.ieoSong.getSongNotAuth(this.songId)).data.body
          this.parseData(this.song)
        })
      }
    },
    followIeo() {
      this.$load(async () => {
        await this.$api.followUnfollow.follow(this.song.ieoId)

        this.dataRequest()
      }, (error) => {
        this.errors.followError = error.data.errors[0].message
        this.$refs.serverErrorPopup.openPopups()
      })
    },
    unfollowIeo() {
      this.$load(async () => {
        await this.$api.followUnfollow.unfollow(this.song.ieoId)
        this.dataRequest()
      }, (error) => {
        this.errors.followError = error.data.errors[0].message
        this.$refs.serverErrorPopup.openPopups()
      })
    },
    buyIeo() {
      this.disableButtonRequestPayment = true
      if (process.env.VUE_APP_ENV_NAME === 'prod') {
        this.addScript('https://payment.payline.com/scripts/widget-min.js')
      } else {
        this.addScript('https://homologation-payment.payline.com/scripts/widget-min.js')
      }
      // this.addScript('https://homologation-payment.payline.com/scripts/widget-min.js')
      this.mongoFlag = true
      setTimeout(() => {
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.closeEvent()
          }
        });
        let header = this.$refs.PaylineWidgetRef.getElementsByClassName('pl-icon-close')
        header[0].addEventListener("click", this.closeEvent, false);
        let payButton = this.$refs.PaylineWidgetRef.getElementsByClassName('pl-pay-btn ')
        payButton[0].addEventListener("click", this.payEvent, false);

      }, 1000)
    },
    payEvent() {
      setTimeout(() => {
        this.$router.push({path: this.$route.path})
      }, 2000)
    },
    closeEvent() {
      var tags = document.getElementsByTagName('script');
      for (var i = tags.length; i >= 0; i--) { //search backwards within nodelist for matching elements to remove
        if ((tags[i] && tags[i].getAttribute('src') != null && (tags[i].getAttribute('src').indexOf('https://homologation-payment.payline.com/scripts/widget-min.js') !== -1 || tags[i].getAttribute('src').indexOf('https://payment.payline.com/scripts/widget-min.js') !== -1))) {
          tags[i].parentNode.removeChild(tags[i]); //remove element by calling parentNode.removeChild()
        }
      }
      let popupBlock = this.$refs.PaylineWidgetRef.getElementsByClassName('pl-modal-dialog')
      popupBlock[0].parentNode.removeChild(popupBlock[0])
      this.disableButtonRequestPayment = false
    },
    addScript(src, callback) {
      var s = document.createElement('script');
      s.setAttribute('src', src);
      s.setAttribute('ref', 'mongoScript')
      s.onload = callback;
      document.body.appendChild(s);
    },
    toggleMusic() {
      if (this.togglePlayerFlag) {
        this.togglePlayerFlag = false
        localStorage.setItem('currentSongPlaying', this.mp3)
        this.$refs[`audioPlayer${this.identifier}${this.index}`].toggleMusic()
      } else {
        this.togglePlayerFlag = true
        this.$refs[`audioPlayer${this.identifier}${this.index}`].toggleMusic()
      }
    },
    convertTo(val) {
      let res
      let time = val
      if (time <= 60) {
        if (time < 10) {
          res = `00:0` + val
        } else {
          res = `00:` + val
        }
      } else {
        let minutes = Math.floor(time / 60);
        if (minutes < 10) {
          minutes = `0${Math.floor(time / 60)}`
        }
        let seconds = time - minutes * 60;
        if (seconds < 10) {
          seconds = `0${time - minutes * 60}`
        }
        res = `${minutes}:${seconds}`
      }
      console.log(res)
      return res
    },
    requestToken() {
      this.$load(async () => {
        this.disableButtonRequestPayment = true
        this.purchaseData = (await this.$api.payment.getPayment(this.formData)).data.body
        this.paymentUrl = this.purchaseData.redirectUrl.split('token=')[1]
        this.paymentFee = this.purchaseData.feeAmount
        setTimeout(() => {
          this.$refs.confirmPopupForCreatePM.openPopups()
          this.disableButtonRequestPayment = false
        }, 500)
      }, error => {
        if (error.data.errors[0].id === "MANGOPAY_INITIAL_EXCEPTION" &&
            error.data.errors[0].message === 'Rate limit exceeded. Please contact support for more assistance') {
          this.$refs.mangopayCallErrorPopup.openPopup()
        }
        if (error.data.errors[0].id === "HTTP_MESSAGE_NOT_READABLE" || error.data.errors[0].id === 'ILLEGAL_FORMAT_EXCEPTION' || error.data.errors[0].id === 'DATA_INTEGRITY_VIOLATION') {
          this.errors.followError = 'Data is not valid'
          this.$refs.serverErrorPopup.openPopups()
          return
        }
        this.errors.followError = error.data.errors[0].message
        this.$refs.serverErrorPopup.openPopups()
      })
    },
    confirmActionEvent() {
      this.formData.paymentType = 'CARD'
      this.requestToken()
      // setTimeout(() => {
      //   this.$refs.confirmPopupForCreatePM.openPopups()
      // }, 500)
    },
    toggleCoAuthorsList() {
      this.coAuthorsListOpen = !this.coAuthorsListOpen
    },
    openFullDescription() {
      this.descriptionOfSong = this.song.description
    },
    closeFullDescription() {
      if (this.song.description) {
        this.descriptionOfSong = this.song.description.slice(0, 200)
      }
    },
  },
  beforeCreate() {
    this.currencyName = process.env.VUE_APP_CURRENCY_NAME_SHORT || 'RR'
  },
  mounted() {
    document.title = 'Song'
    this.screenWidthCheck()
    this.lengthWatcher()
    this.scrollToId('my-content')
    this.dataRequest()
    // setTimeout(() => {
    //   this.closeFullDescription()
    // }, 500)
    this.urlPath = window.location.href
    setTimeout(() => {
      let userName = JSON.parse(localStorage.getItem('headerFirstName'))
      this.checkOwner = this.singerUsername === userName
    }, 1000)

    localStorage.setItem('songUuid', this.$route.params.id)

    // document.getElementById("audio-range").oninput = function() {
    //   var value = (this.value-this.min)/(this.max-this.min)*100
    //   this.style.background = 'linear-gradient(to right, #82CFD0 0%, #82CFD0 ' + value + '%, #fff ' + value + '%, white 100%)'
    // };
  },
  components: {
    BidsChart,
    Footer,
    Header,
    FlipCountdown,
    SongIeoBids,
    ConfirmPopupForPM,
    ServerErrorPopup,
    DisclaimerPmPopup,
    VerificationMessagePopup,
    ConfirmPopupForBuyPM,
    MangopayCallErrorPopup,
    SongWinnersList,
    AudioPlayer
  }
}
</script>

<style scoped>


/* animation  */

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* end animation  */

ul, li {
  list-style: none;
  margin: 0;
  padding: 0;
}

.preload-block {
  height: 941px;
}

.song-price-value-wrap input {
  width: 100%;
}

.song-winner-list-wrapper {
  margin-top: 32px;
}

.song-winner-list-final_price {
  margin-left: 20px;
  font-weight: 500;
  text-transform: uppercase;
  color: #000000;
}

.song-winners-list {
  border: 1px solid #EFEFEF;
  border-radius: 5px;
  max-height: 600px;
}

.song-winners-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 16px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
}

.song-winners-item.top {
  padding: 16px;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: #272727;
  background: #F5F5F5;
}

.song-winners-item-right, .song-winners-item-left {
  width: 50%;
}

.song-winners-item-right {
  display: flex;
  justify-content: space-between;
}

.song-winners-item-right__bid, .song-winners-item-right__amount {
  display: flex;
  width: 50%;
}

.song-winners-item-right__bid {
  justify-content: center;
}

.song-winners-item-right__amount {
  justify-content: flex-end;
}

.song-winners-list .song-investor-show-wrap {
  width: calc(100% - 32px);
  margin: 0 auto 16px auto;
}

.song-winners-item-wrapper {
  max-height: 500px;
}

.song-info-used-item-value-wrap.commission {
  background: #F9F9F9;
}

.holder-progress-bar.ipr-bid .progress-title {
  color: #FFFFFF;
}

.holder-progress-bar:last-child {
  margin-top: 5px;
}

.holder-progress-bar.sold .progress-count {
  color: #FF0090;
}

.error-message {
  color: red;
  position: absolute;
  margin: 0;
  bottom: -30px;
  left: 0;
}

.song-delta-total .error-message {
  bottom: -21px;
  font-size: 14px;
}

.is-song-template .pending-ieo-list-item-name-artist-link {
  font-size: 24px;
  line-height: 28px;
  color: #3B3B3B;
}

.hint-item__icon {
  fill: black;
  opacity: 0.2;
  transition: .5s ease;
}

.hint-item__icon:hover {
  opacity: 1;
}

.song-content-wrap .song-info-used-item-descr button.v-btn {
  height: unset;
  min-width: unset;
  padding: 0 0 0 5px;
  background-color: transparent;
  text-transform: unset;
  box-shadow: unset;
}

.audio-player-wrapper {
  height: 70px;
  color: #FFFFFF;
}


@media only screen and (max-width: 768px) {
  .song-info-used-item-value-wrap.commission {
    background: #fff;
  }

  .is-song-template .pending-ieo-list-item-name-artist {
    font-size: 18px;
    line-height: 21px;
  }
}

</style>
